import { useMemo } from 'react';
import { Roles } from 'app/auth/authRoles';
import useLoggedInUser from './useLoggedInUser';

type useUserRolesReturnType = {
  roles: string[];
  isSupport: boolean;
  isPharmacist: boolean;
  isPharmacyAdmin: boolean;
  isPrescriber: boolean;
};

export default function useUserRoles(): useUserRolesReturnType {
  const user = useLoggedInUser();
  const roles = user?.roles ?? [];
  const rolesKey = JSON.stringify(roles);

  return useMemo(
    () => ({
      roles,
      isSupport: roles.includes(Roles.SUPPORT),
      isPharmacist: roles.includes(Roles.PHARMACIST),
      isPharmacyAdmin: roles.includes(Roles.PHARMACY_ADMIN),
      isPrescriber: roles.includes(Roles.PRESCRIBER),
    }),
    [rolesKey]
  );
}
